export const tabConfig = [
  {
    name: 'judge/trial-mgt',
    displayName: '我的案件',
    className: 'icon_my_trial'
  },
  {
    name: 'judge/my',
    displayName: '个人中心',
    className: 'icon_personal'
  }
]



// WEBPACK FOOTER //
// ./src/views/judge/layout/config.js